import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Hero from "../../components/accomodation/hero/Hero";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import Promise from "../../components/accomodation/promise/Promise";
import Working from "../../components/accomodation/working/Working";
import Faq from "../../components/accomodation/faq/Faq";
import { IMAGES } from "../../data/images";
import promise1 from "../../assets/images/promise1.webp";
import promise2 from "../../assets/images/promise2.webp";
import promise3 from "../../assets/images/promise3.webp";
import { FAQS } from "../../data/faqs";

const promises = [
  {
    image: promise1,
    title: "Verified Properties",
    description:
      "All accommodations meet the highest safety and hygiene standards for a comfortable living experience.",
  },
  {
    image: promise2,
    title: "24/7 Support",
    description:
      "Our accommodation team is available around the clock to assist with any issues during your stay.",
  },
  {
    image: promise3,
    title: "Best Prices",
    description:
      "Exclusive deals with partner housing providers — no hidden fees, transparent pricing.",
  },
];

const workingData = [
  {
    heading: "Browse",
    description:
      "Explore hostels, dormitories, and apartments near your university from our verified listings.",
  },
  {
    heading: "Choose",
    description:
      "Compare options by price, amenities, distance to campus, and reviews from fellow students.",
  },
  {
    heading: "Book",
    description:
      "Secure your accommodation with our booking assistance. We handle lease agreements and payments.",
  },
];

function Accomodation() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero
        heading="Student Accommodation"
        description="Find Your Home, Away From Home"
        img={IMAGES.studentAccommodation}
      />
      <Promise
        heading="The Ever Sky Promise"
        description="We provide maximum support to ensure your comfort and safety in student housing abroad."
        promises={promises}
      />
      <Working data={workingData} />
      <Faq data={FAQS.accommodation} />
      <div className="text-center py-8">
        <button
          onClick={() => navigate("/pricing")}
          className="bg-blue-600 text-white py-3 px-8 rounded-lg hover:bg-blue-700 font-semibold"
        >
          Book Accommodation — ₹2,499
        </button>
      </div>
      <Footer />
    </>
  );
}

export default Accomodation;
